angular.module("dx.webapp.class", [
	"digiexam.services",
	"dx.webapp.student",

	"ngPasteFrom",
	"ngRoute",
]);
